import n from "axios";
const a = () => {
  let e;
  return {
    createToken: () => (e = n.CancelToken.source(), e.token),
    cancel: () => {
      e && (e.cancel(), e = void 0);
    },
    getToken: () => e == null ? void 0 : e.token
  };
};
export {
  a as createCanceler
};
